<app-invoices [invoices]="(invoices | async)!" (editInvoice)="editInvoice($event)"></app-invoices>
